import { shortenBlockId } from './getBlockShortId';
export function getHeaderDOMElementFromId(editor, blockId) {
  // While normalizing, headers sometimes don't have a blockId
  if (!blockId) {
    return null;
  }

  return editor.el.querySelector("[data-scroll-id^=\"".concat(shortenBlockId(blockId), "\"]"));
}